import { usePaywallState } from "components/PaywallStateProvider";

export default function useIsSourceLocked(sourceType) {
  const { user } = usePaywallState();

  const isLocked = !user?.monetization.data.features.sources.includes(sourceType);

  return isLocked;
}
